const messages: Record<string, string> = {
	'vehicleRegistrationDocument.title': '自動車登録証',
	'vehicleRegistrationDocument.description':
		'指定された自動車登録証の面を鮮明に撮影してアップロードしてください。',
	'vehicleRegistrationDocument.RegistrationDocument.title': '自動車登録証の表面',
	'vehicleRegistrationDocument.RegistrationDocument.description':
		'自動車登録証の表面を鮮明に撮影してください。',
	'vehicleRegistrationDocument.RegistrationDocument.headline': '自動車登録証の表面',
	'vehicleRegistrationDocument.RegistrationDocument.exampleModalTitle': '自動車登録証の表面 - 例',
	'vehicleRegistrationDocument.RegistrationDocument.validationRequired': '自動車登録証の表面',
	'vehicleRegistrationDocument.RegistrationDocumentInside.title': '自動車登録証の裏面',
	'vehicleRegistrationDocument.RegistrationDocumentInside.description':
		'自動車登録証の裏面を鮮明に撮影してください。',
	'vehicleRegistrationDocument.RegistrationDocumentInside.headline': '自動車登録証の裏面',
	'vehicleRegistrationDocument.RegistrationDocumentInside.exampleModalTitle':
		'自動車登録証の裏面 - 例',
	'vehicleRegistrationDocument.RegistrationDocumentInside.validationRequired': '自動車登録証の裏面',
	'vehicleRegistrationDocument.validationHeadline': '写真が不足しています',
	'vehicleRegistrationDocument.validationDescription': '次の写真を追加してください:',
	'landing.stepDescription.vehicleRegistrationDocument': '自動車登録証を撮影する',
	'review.stepDescription.vehicleRegistrationDocument': '自動車登録証',
	'approval.calculationPDF': '原価計算レポートPDF',
	'approval.description':
		'損失額は、控除を考慮していません。 控除可能。VATは含まれません。 これは、車両がボディショップで修理された場合にのみ適用され、車両を修理した場合は返金されます。',
	'approval.headline': '損傷の程度',
	'approval.labourCosts': '技術料',
	'approval.lacquerCosts': '塗料',
	'approval.payoutAmount': '支払額',
	'approval.repairAmount': '損傷の程度',
	'approval.retention': 'Retention',
	'approval.sparePartCosts': 'Spare parts',
	'bodyshop.headline': 'Workshops in your area',
	'bodyshop.mainError': 'Workshops in your area could not be loaded ...',
	'bodyshop.mainLoader.loadingLocation': 'Determining your location ...',
	'bodyshop.mainLoader.loadingWorkshop': 'Loading workshops in your area ...',
	'button.accept': 'Accept',
	'button.addLater': 'Add later',
	'button.backchangeImage': '戻ると画像を変更',
	'button.call': 'Call',
	'button.changeImage': 'Change photo',
	'button.close': 'Close',
	'button.contact': 'Contact',
	'button.continue': '継続する',
	'button.dataProtection': 'Data protection',
	'button.deleteImage': 'Delete photo',
	'button.help': 'ヘルプ',
	'button.imprint': 'Imprint',
	'button.liveChat': 'Live-Chat',
	'button.next': '次へ',
	'button.ok': 'Ok',
	'button.onApproval': 'Get calculation',
	'button.onCallback': 'Callback Note received',
	'button.onInsuranceExpert': 'Steering out to insurance expert',
	'button.onLanding': 'Without onboarding',
	'button.onOnboarding': 'Onboarding',
	'button.onVideocall': 'Video review',
	'button.payout': 'はい、支払いを希望します',
	'button.prev': 'チューリッヒ',
	'button.repair': '修理の手配',
	'button.select': 'Select',
	'button.selectPhoto': 'Select a photo',
	'button.showTutorial': 'Watch tutorial',
	'button.showWhatsApp': 'WhatsApp-Message',
	'calculationDetailsModal.labourCosts': 'Labour costs',
	'calculationDetailsModal.lacquerCosts': 'Lacquer costs',
	'calculationDetailsModal.spareParts': 'Spare parts',
	'calculationDetailsModal.total': 'Total',
	'callback.description':
		'Unfortunately no calculation was possible in your case. We will call you within 24 hours on weekdays to discuss further action with you.',
	'callback.headline': 'Your damage has been assessed.',
	'completeDamageDescriptionModal.description': 'Please describe briefly how the damage occurred.',
	'completeDamageDescriptionModal.headline': 'Hint',
	'completePayoutInformationModal.accountHolder': 'Account holder',
	'completePayoutInformationModal.accountHolderIBAN': 'IBAN of the account holder',
	'completePayoutInformationModal.description': 'Please add the following information:',
	'completePayoutInformationModal.headline': 'Hint',
	'completePoliceReportModal.description': 'Please add the following information:',
	'completePoliceReportModal.hasAccidentOnAlcoholOrDrugs':
		'Were you under the influence of alcohol or drugs?',
	'completePoliceReportModal.hasAccidentOwnFault': 'Did you cause the accident?',
	'completePoliceReportModal.hasDamageDescription': 'Damage description',
	'completePoliceReportModal.hasPoliceInformed': 'Was the accident recorded by police?',
	'completePoliceReportModal.hasPoliceReportExists': 'Is there a police report?',
	'completePoliceReportModal.headline': 'Hint',
	'completeVehicleImagesModal.description': 'Please add the following information:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Photo of the vehicle front left',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Photo of the vehicle rear right',
	'completeVehicleImagesModal.headline': 'Hint',
	'completeVehicleInformationModal.description': 'Please add the following information:',
	'completeVehicleInformationModal.hasValidMileage': 'Mileage of the vehicle',
	'completeVehicleInformationModal.headline': 'Hint',
	'completeVehicleInformationModal.isRegistrationDocumentUploaded':
		'Photo of the vehicle registration',
	'damageDescription.button.back': '« チューリッヒ',
	'damageDescription.button.help': 'ヘルプ',
	'damageDescription.button.next': '次へ »',
	'damageDescription.headline.first': '損傷の説明',
	'damageDescription.paragraph.first':
		'どのように損傷ができたかを簡単に説明してください。 携帯電話の音声入力を使用することもできます。 テキストフィールドをタップして、マイク記号を押したままにします。',
	'damageDescription.placeholder':
		'例：交差点で、別の車両が自分の車両を脇へ追い詰めてきたため、前側の左フェンダーが押し込まれた。',
	'damageImages.additionalImages': '損傷写真の追加',
	'damageImages.description':
		'異なるアングルから損傷写真を最低{imageCount, number}枚撮影してください（クローズアップ/コンポーネント全体）。 重要：損傷部分全体が確認できるように撮影してください。 写真に基づいて、損害の計算をします',
	'damageImages.headline': '損傷写真',
	'damageImages.optionalDamageImages': '必要に応じ損傷部分の写真を追加し、損傷部分を明確にします。',
	'damageImagesExampleModal.headline': 'Damage pictures - example',
	'feedback.button.send': 'Send feedback',
	'feedback.description':
		'We hope that you were satisfied with our service and look forward to your feedback.',
	'feedback.headline': 'Thank you for using application!',
	'feedback.rating': 'How do you rate claims processing with EasyClaim?',
	'helpModal.description':
		"You can't get any further with one step or have questions about the application? Please contact us! We will be glad to help you:",
	'helpModal.headline': 'Help',
	'imageRecognitionMismatchModal.headline': 'Are you sure you added the right photo?',
	'insuranceExpert.description':
		'Thank you very much. Your damage has been assessed. We will get in touch with you shortly to discuss the next steps with you.',
	'insuranceExpert.headline': 'We will contact you shortly.',
	'label.details': '詳細',
	'landing.aboutEasyclaim': 'EasyClaimの背後には何がありますか？',
	'landing.dataPrivacyLink': 'プライバシーポリシーに同意する',
	'landing.headline': 'わずか数ステップで自動車の損傷を処理します。',
	'landing.stepDescription.damageDescription': '損傷の説明',
	'landing.stepDescription.damageImages': '損傷写真の撮影',
	'landing.stepDescription.overviewshots': '車両の概要を追加',
	'landing.stepDescription.vehicleDescription': '車両の詳細を指定',
	'loader.error': 'Your process could not be loaded. Please try again later...',
	'loader.loading': 'Loading data ...',
	'mainMenu.contact': 'Contact us',
	'mainMenu.contact.officeHours': 'Our service times: Monday - Friday 8:00 - 20:00',
	'mainMenu.contactDescription':
		'Do you have any questions? give us a call using this phone number: {hotlineNumber}',
	'mainMenu.dataPrivacy': 'Data protection',
	'mainMenu.description': 'Click on the button to view the privacy policy.',
	'mainMenu.headline': 'Data protection',
	'mainMenu.imprintDescription': 'Click on the button to open the imprint.  ',
	'mainMenu.imprintLink': 'Imprint',
	'onboarding.button.finish': "Let's go »",
	'onboarding.button.next': 'Next »',
	'onboarding.headline.first': 'Take damage pictures',
	'onboarding.headline.second': 'Let calculate',
	'onboarding.headline.third': 'Get calculation',
	'onboarding.link.dataPrivacy': 'Accept data protection',
	'onboarding.link.skip': 'Skip',
	'onboarding.paragraph.first':
		'A car expert uses the pictures to calculate the amount of damage to the vehicle.',
	'onboarding.paragraph.second':
		'Simply upload a photo from the vehicle registration and the damage of the car.',
	'onboarding.paragraph.third':
		'Within a few hours you will receive the calculation. You can now devcide to pay out the repairamount or to have the vehicle repaired at the bodyshop ',
	'payout.button.back': '« Back',
	'payout.button.help': 'Help',
	'payout.button.payoutConfirm': 'Confirm payout »',
	'payout.headline.first': 'Almost Done!',
	'payout.headline.second': 'Bank account owner',
	'payout.headline.third': 'IBAN',
	'payout.paragraph':
		'To settle the amount of {payoutAmount} to your bank account, we only need your bank details. We will arrange a transaction to your account immediately.',
	'registrationDocumentExampleModal.headline': 'Photo of vehicle registration - example',
	'review.button.back': '« チューリッヒ',
	'review.button.close': '完了 »',
	'review.button.help': 'ヘルプ',
	'review.button.next': '次へ',
	'review.headline.first': '確認',
	'review.paragraph.first':
		'[完了]をタップする前に確認してください。 入力した情報の概要が表示されます。',
	'thanksForFeedback.headline.first': 'Thank you for your Feedback!',
	'thanksForFeedback.paragraph.first':
		"Your opinion about our service is very important to us. We're constantly working to improve EasyClaim and your feedback is an important key to our success.",
	'tutorialModal.headline.first': 'What is behind EasyClaim?',
	'tutorialModal.paragraph.first':
		'EasyClaim is suitable for almost all body damage to a car. Your damage pictures and the accident description will be forwarded directly to one of our 350 car experts where the pictures are analyzed and claimed. Our expert teams have all worked practically for years in the workshop themselves and understand their craft very well. In addition, for more than 16 years, we have been examining claims and maintenance receipts from almost all major insurance companies and vehicle manufacturers. Your data will be compared with over 50 million verified transactions from the past and supplemented by the practical know-how of our car experts. In addition, we have built up a very extensive database over the years. We know what each screw at every manufacturer for each model costs, and what steps are needed to replace or repair a car part.',
	'tutorialModal.paragraph.second':
		'All these circumstances allow us to provide you with a realistic cost estimate in such a short time.',
	'upload.message':
		'Your data will be uploaded. Depending on your internet connection, this process can take several minutes.',
	'vehicleImages.details.first':
		'フロントナンバープレートを含む、車両の前部と左側の全体を示す車の写真を追加します。',
	'vehicleImages.details.second':
		'リアナンバープレートを含め、車両のリアと右側全体を示す車の写真を追加します。',
	'vehicleImages.overviewPhotos': '車両写真',
	'vehicleImagesExampleModal.button.close': 'Close',
	'vehicleImagesExampleModal.headline.first': 'Overview Car – Example',
	'vehicleInformation.button.back': '« チューリッヒ',
	'vehicleInformation.button.help': 'ヘルプ',
	'vehicleInformation.button.next': '次へ »',
	'vehicleInformation.headline.first': '車両の詳細',
	'vehicleInformation.headline.second': '自動車検査証の写真',
	'vehicleInformation.headline.third': '走行距離',
	'vehicleInformation.paragraph.first':
		'自動車検査証の内側を撮影。 撮影した写真から、 車両識別番号や登録日を読み取ります。',
	'vehicleInformation.paragraph.second':
		'車両の走行距離を入力してください。この情報は正確な交換費用の決定をする数値となります。',
	'vehicleInformation.placeholder': 'eg. 150000 Miles',
	'waitForAudit.callBack': 'ご不明な点がございましたら、お気軽にお問い合わせください。',
	'waitForAudit.description':
		'入力した情報が送信されました。 弊社の専門家が情報に基づいて損害を確認し、2時間以内に費用を計算いたします（祝日を除く月曜日から金曜日の午前8時から午後8時、土曜日の午前8時から午後12時）。 計算が完了次第、電子メールまたはSMSで通知されます。',
	'waitForAudit.thankYou': 'ご協力ありがとうございました',
	'withoutPayout.description':
		'修理を希望しますか？ お住まいの地域で資格のあるワークショップを選択するお手伝いをさせていただきます。',
	'withoutPayout.footer': '詳細な手順については、できるだけ早くご連絡いたします。',
	'withoutPayout.headline': '私たちはあなたをサポートしたいと思います！',
	'timeout.bottom': ' ',
	'testcasemodal.headline': 'テストケースの警告！',
	'testcasemodal.accept': '承認',
	'testcasemodal.paragraph': 'これはテストケースであることに注意してください。',
	'testcasewarningalert.paragraph': 'これはテストケースです！',
};

export default messages;
